// Host composition: feature modules never import host or sibling business code.
import { api } from '../config';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as stockSelection from './stock-selection';
import * as eventGap from './event-gap';
import * as macroRotation from './macro-rotation';
import * as extremeMovers from './extreme-movers';
import * as multibaggerSelection from './multibagger-selection';
import * as analystRevision from './analyst-revision';
import * as extremeMoversOhlc from './extreme-movers-ohlc';
import * as strategies from './strategies';
const plugins = [
  ...(process.env.REACT_APP_STOCK_SELECTION_ENABLED === '0' ? [] : [stockSelection]),
  ...(process.env.REACT_APP_EVENT_GAP_ENABLED === '0' ? [] : [eventGap]),
  ...(process.env.REACT_APP_MACRO_ROTATION_ENABLED === '0' ? [] : [macroRotation]),
  ...(process.env.REACT_APP_EXTREME_MOVERS_ENABLED === '0' ? [] : [extremeMovers]),
  ...(process.env.REACT_APP_MULTIBAGGER_SELECTION_ENABLED === '0' ? [] : [multibaggerSelection]),
  ...(process.env.REACT_APP_ANALYST_REVISION_ENABLED === '0' ? [] : [analystRevision]),
  ...(process.env.REACT_APP_EXTREME_MOVERS_OHLC_ENABLED === '0' ? [] : [extremeMoversOhlc]),
  ...(process.env.REACT_APP_STRATEGIES_ENABLED === '0' ? [] : [strategies]),
];
const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem('authUser') || 'null')?.token || null;
  } catch {
    return null;
  }
};
plugins.forEach(p => p.configure({
  apiUrl: api.API_URL,
  getToken
}));
export const moduleRoutes = plugins.flatMap(p => p.routes);
export const moduleNavigation = plugins.map(p => p.navigation);
export const modulePublicNavigation = plugins.map(p => p.publicNavigation).filter(Boolean);
export function useModuleNavigation({ admin, paid }) {
  const { pathname } = useLocation();
  const [expanded, setExpanded] = useState(null);
  useEffect(() => {
    setExpanded(plugins.find(p => pathname.startsWith(p.navigation.link))?.navigation.id || null);
  }, [pathname]);
  // A mode may have no menu entry for this reader (an experiment shows to administrators only).
  return useMemo(() => plugins.map(plugin => {
    const item = plugin.getNavigation({admin, paid});
    if (!item) return null;
    return { ...item, link: '/#', stateVariables: expanded === item.id,
      click: event => { event.preventDefault(); setExpanded(current => current === item.id ? null : item.id); },
    };
  }).filter(Boolean), [admin, paid, expanded]);
}
